export default {
  RSUData: {},
  DBData: {},
  storageData: {},
};
